import { render, staticRenderFns } from "./EmployeesTab.vue?vue&type=template&id=19a085c5&scoped=true"
import script from "./EmployeesTab.vue?vue&type=script&lang=ts"
export * from "./EmployeesTab.vue?vue&type=script&lang=ts"
import style0 from "./EmployeesTab.vue?vue&type=style&index=0&id=19a085c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a085c5",
  null
  
)

export default component.exports